import { render } from "./tocgenerate.vue?vue&type=template&id=121bc6bf&scoped=true"
import script from "./tocgenerate.js?vue&type=script&lang=js"
export * from "./tocgenerate.js?vue&type=script&lang=js"

import "./tocgenerate.vue?vue&type=style&index=0&id=121bc6bf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121bc6bf"]])

export default __exports__